/// <reference path='meevoMessenger.module.ts' />
/// <reference path='../../../../typings/index.d.ts' />

module Meevo.Plugins.MeevoMessenger{
    'use strict';

    import IMeevoMessengerSettings = Meevo.Model.IMeevoMessengerSettings;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import IMeevoMessengerNotification = Meevo.Model.IMeevoMessengerNotification;
    import TMeevoMessengerClassification = Meevo.Model.TMeevoMessengerClassification;
    export class MeevoMessengerController{

        static $inject = [
            '$scope',
            'meevo.components.busy.BusyService',
            'meevo.ContextParams',
            '$rootScope',
            '$translate',
            'meevo.components.common.SecurityService',
            'meevo.plugins.meevoMessenger.meevoMessengerApiService',
            '$state',
            'meevo.AppSettings',
        ];

        private activeMessenger: MessengersEnum = null;
        public securityKeys = Meevo.Components.Common.SecurityKeys;
        public securityParts = Meevo.Components.Common.SecurityParts;
        public isClientMessaging: boolean = true;
        public isInboundSmsForClient: boolean = true;
        public isInitialized = false;
        public isMeevoMessengerInitialized = false;
        public isAutoReplyEnabled = false;
        public sideNavClientInfo = false;
        public meevoMessengerSettings: IMeevoMessengerSettings = null;
        public isPulsing: boolean = false;
        public inboundSmsFor: MessengersEnum;
        private messengerClassification = {
            ARRIVALS: 'ARRIVALS',
            TEXTEL: 'TEXTEL',
            CLIENTAPP: 'MEGO',
            TWOWAYSMS: 'SMS'
        };
        private readonly pluginName: string =  'meevoMessenger';

        private meevoMessengerArrivals: IMeevoMessengerModules =  {
            messengerName: this.$translate.instant('SECTION_ARRIVALS'),
            messengerType: MessengersEnum.MeevoMessengerArrivals,
            isShowSubs: this.activeMessenger == MessengersEnum.MeevoMessengerArrivals,
            icon: 'assets/images/icons/tab_arrivals.svg',
            isPulsing: false,
            meevoSecure: {
                securityKey: this.securityKeys.MANAGEMENT_MEEVOMESSENGER_ARRIVALS + this.securityParts.KEY_PART_READ,
                secureDelete: this.securityKeys.MANAGEMENT_MEEVOMESSENGER_ARRIVALS_CHATWINDOW_DELETECONVERSATION + this.securityParts.KEY_PART_DELETE,
                secureUnDelete: this.securityKeys.MANAGEMENT_MEEVOMESSENGER_ARRIVALS_CHATWINDOW_UNDELETECONVERSATION + this.securityParts.KEY_PART_UNDELETE,
                secureSettings: this.securityKeys.MANAGEMENT_MEEVOMESSENGER_MEEVOMESSENGERSETTINGS_ARRIVALSSETTINGS + this.securityParts.KEY_PART_READ
            },
            messengerSubModule: []
        };

        private meevoMessengerTextel: IMeevoMessengerModules =  {
            messengerName: this.$translate.instant('SECTION_TEXTEL'),
            messengerType: MessengersEnum.MeevoMessengerTextel,
            isShowSubs: this.activeMessenger == MessengersEnum.MeevoMessengerTextel,
            icon: 'assets/images/icons/tab_textel.svg',
            isPulsing: false,
            meevoSecure: {
                securityKey: this.securityKeys.INTEGRATION_TEXTEL + this.securityParts.KEY_PART_READ,
                secureDelete: this.securityKeys.INTEGRATION_TEXTEL_TAB_CHATWINDOW_DELETECONVERSATION + this.securityParts.KEY_PART_DELETE,
                secureUnDelete: this.securityKeys.INTEGRATION_TEXTEL_TAB_CHATWINDOW_UNDELETECONVERSATION + this.securityParts.KEY_PART_UNDELETE,
                secureSettings: this.securityKeys.INTEGRATION_TEXTEL_TAB_TEXTELSETTINGS + this.securityParts.KEY_PART_READ
            },
            messengerSubModule: [
                {
                    messengerSubModuleName: this.$translate.instant('HERO_SUB_CLIENTS'),
                    isClient: true,
                }, {
                    messengerSubModuleName: this.$translate.instant('LABEL_EMPLOYEES'),
                    isClient: false,
                }
            ]
        };

        private meevoMessengerClientApp: IMeevoMessengerModules =  {
            messengerName: this.$translate.instant('SECTION_ME_GO'),
            messengerType: MessengersEnum.MeevoMessengerClientApp,
            isShowSubs: this.activeMessenger == MessengersEnum.MeevoMessengerClientApp,
            icon: 'assets/images/icons/tab_arrivals.svg',
            isPulsing: false,
            meevoSecure: {
                securityKey: this.securityKeys.INTEGRATION_CLIENTAPP_TAB_MESSENGER + this.securityParts.KEY_PART_READ,
                secureSettings: this.securityKeys.INTEGRATION_CLIENTAPP_TAB_CLIENTAPPSETTINGS + this.securityParts.KEY_PART_READ
            },
            messengerSubModule: []
        };


        private meevoMessengerTwoWaySms: IMeevoMessengerModules = {
            messengerName: this.$translate.instant('SECTION_TWO_WAY_SMS'),
            messengerType: MessengersEnum.MeevoMessengerTwoWaySms,
            isShowSubs: this.activeMessenger == MessengersEnum.MeevoMessengerTwoWaySms,
            icon: 'assets/images/icons/tab_2waysms.svg',
            isPulsing: false,
            meevoSecure: {
                securityKey: this.securityKeys.INTEGRATION_TWOWAYSMS + this.securityParts.KEY_PART_READ,
                secureDelete: this.securityKeys.INTEGRATION_TWOWAYSMS_TAB_CHATWINDOW_DELETECONVERSATION + this.securityParts.KEY_PART_DELETE,
                secureUnDelete: this.securityKeys.INTEGRATION_TWOWAYSMS_TAB_CHATWINDOW_UNDELETECONVERSATION + this.securityParts.KEY_PART_UNDELETE,
                secureSettings: this.securityKeys.INTEGRATION_TWOWAYSMS_TAB_TWOWAYSMSSETTINGS + this.securityParts.KEY_PART_READ
            },
            messengerSubModule: [
                {
                    messengerSubModuleName: this.$translate.instant('HERO_SUB_CLIENTS'),
                    isClient: true,
                }, {
                    messengerSubModuleName: this.$translate.instant('LABEL_EMPLOYEES'),
                    isClient: false,
                }
            ]
        };


        public meevoMessengerModules: {[key: number]: IMeevoMessengerModules} = {
            [MessengersEnum.MeevoMessengerArrivals]: null,
            [MessengersEnum.MeevoMessengerClientApp]: null,
            [MessengersEnum.MeevoMessengerTextel]: null,
            [MessengersEnum.MeevoMessengerTwoWaySms]: null
        };
        private state: any;

        constructor(protected $scope: angular.IScope,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected contextParams: Meevo.IContextParams,
                    protected $rootScope: angular.IRootScopeService,
                    protected $translate: angular.translate.ITranslateService,
                    protected securityChecker: Meevo.Components.Common.ISecurityService,
                    protected meevoMessengerApiService: IMeevoMessengerApiService,
                    protected $state: any,
                    protected appSettings: Meevo.Components.Common.IAppSettings
        ) {
            this.initMessengerModules(contextParams);

            this.$scope.$on(Meevo.Components.Common.Messages.MEEVO_MESSENGER_PROCESS_INBOUND_MESSAGE, (event: any, notification: IMeevoMessengerNotification) => {
                this.$scope.$broadcast(MeevoMessengerMessages.PROCESS_INBOUND_MESSAGE, notification);

                if(!!notification.clientId || !!notification.employeeId) {
                    this.isInboundSmsForClient = !!notification.clientId;
                } else {
                    this.isInboundSmsForClient = this.isClientMessaging;
                }

                this.$scope.$apply(() => {
                    this.isPulsingModule(notification.classification, notification.isInbound);
                });
            });

            this.$scope.$on(MeevoMessengerMessages.END_MODULE_PULSING, (event: any, pulsing: {classification: TMeevoMessengerClassification, isPulsing: boolean}) => {
                this.isPulsingModule(pulsing.classification, pulsing.isPulsing);
            });

            if (this.contextParams && this.contextParams.params && typeof this.contextParams.params.isClient == "boolean" ) {
                this.openClientOrEmployeeConversation(this.contextParams.params.isClient)
            }

            this.$scope.$on('$stateChangeSuccess',(event, toState, toParams, fromState) => {

                if (toState.params.isHasPulse) {
                    this.initialPulsing(toState.params);
                }
            });
        }

        private initMessengerModules(contextParams: IContextParams): void {
            this.meevoMessengerApiService.isArrivalsEnabled().then((enabled: boolean) => {
                this.meevoMessengerModules[MessengersEnum.MeevoMessengerTextel] = this.meevoMessengerTextel;
                this.meevoMessengerModules[MessengersEnum.MeevoMessengerArrivals] = this.meevoMessengerArrivals;
                this.meevoMessengerModules[MessengersEnum.MeevoMessengerClientApp] = this.meevoMessengerClientApp;
                this.meevoMessengerModules[MessengersEnum.MeevoMessengerTwoWaySms] = this.meevoMessengerTwoWaySms;

                if (!enabled) {
                    delete this.meevoMessengerModules[MessengersEnum.MeevoMessengerArrivals];
                }

                this.openMeevoMessenger(contextParams.params, enabled);
                if (this.$state.current && this.$state.current.params && this.$state.current.params.isHasPulse) {
                    this.initialPulsing(this.$state.current.params)
                }

            });
        }

        private initialPulsing(params): void {
            const nameIncomingMessageModule = Object.keys(params['newConversations']);
            if (nameIncomingMessageModule.length) {
                for(let i = 0; i < nameIncomingMessageModule.length; i++) {
                    this.isPulsingModule(<TMeevoMessengerClassification>nameIncomingMessageModule[i], params.isHasPulse);
                }
            }
        }

        openMeevoMessenger(contextParams: angular.ui.IStateParamsService, isArrivalsEnabled: boolean) {
            let securityKeyEnumsMap: { [x: string]: [MessengersEnum, string] } = { 
                //the order is matter here
                [this.meevoMessengerTwoWaySms.meevoSecure.securityKey]: [MessengersEnum.MeevoMessengerTwoWaySms, this.messengerClassification.TWOWAYSMS],
                [this.meevoMessengerTextel.meevoSecure.securityKey]: [MessengersEnum.MeevoMessengerTextel, this.messengerClassification.TEXTEL],
                [this.meevoMessengerClientApp.meevoSecure.securityKey]: [MessengersEnum.MeevoMessengerClientApp, this.messengerClassification.CLIENTAPP],
                [this.meevoMessengerArrivals.meevoSecure.securityKey]: [MessengersEnum.MeevoMessengerArrivals, this.messengerClassification.ARRIVALS]
            }

            const selectMessengerByPriority = () => {
                const availabelKeyModule = Object.keys(securityKeyEnumsMap).find(key => {
                    return this.securityChecker.checkCachedSecurityKey(key) === SecurityAccessEnum.Grant;
                })
                this.toggleActiveMessenger(securityKeyEnumsMap[availabelKeyModule][0]);
            }

            if (contextParams && contextParams.convoInput) {

                const normalizeConvo = (value: string) => value == "capacity" ? "textel" : value;
                const convo = normalizeConvo(contextParams.convoInput).toUpperCase();
                const securityKeyToOpen = Object.keys(securityKeyEnumsMap).find(key => securityKeyEnumsMap[key][1].includes(convo));

                if (securityKeyToOpen) {
                    this.securityChecker.checkSecurityKey(securityKeyToOpen).then((access) => {
                        if (access !== SecurityAccessEnum.Grant || (securityKeyToOpen === this.meevoMessengerArrivals.meevoSecure.securityKey && !isArrivalsEnabled)) {
                            delete securityKeyEnumsMap[securityKeyToOpen];
                            return selectMessengerByPriority();
                        }

                        return this.toggleActiveMessenger(securityKeyEnumsMap[securityKeyToOpen][0]);
                    });
                }
            } 

            selectMessengerByPriority();
        }

        toggleActiveMessenger(messenger: MessengersEnum): void {
            if (this.activeMessenger == messenger) return;

            for (let mssngr in this.meevoMessengerModules) {
                this.meevoMessengerModules[mssngr].isShowSubs = this.meevoMessengerModules[mssngr].messengerType == messenger
            }

            this.activeMessenger = messenger;
        }

        refreshArrivals() {
            this.$scope.$broadcast(MeevoMessengerMessages.REFRESH_ARRIVALS_CONVERSATION)
        }

        refreshClientApp() {
            this.$scope.$broadcast(MeevoMessengerMessages.REFRESH_CLIENT_APP_CONVERSATION)
        }

        refreshConversations(): void {
            switch (this.activeMessenger) {
                case MessengersEnum.MeevoMessengerArrivals:
                    this.refreshArrivals();
                    break;
                case MessengersEnum.MeevoMessengerClientApp:
                    this.refreshClientApp();
                    break;
                default:
                    this.openClientOrEmployeeConversation(this.isClientMessaging, true);
                    break;
            }
        }

        deletingConfirmation() {
            this.$scope.$broadcast(MeevoMessengerMessages.DELETING_CONVERSATION_CONFIRMATION);
        }

        undeleteModal() {
            this.$scope.$broadcast(MeevoMessengerMessages.UNDELETE_CONVERSATION_MODAL);
        }

        openSettings() {
            this.$scope.$broadcast(MeevoMessengerMessages.OPEN_MEEVOMESSENGER_SETTINGS);
        }

        goToState(stateName: keyof Meevo.Components.Common.IRouteNames) {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.twoWaySmsOnboarding,
            });
        }

        openClientOrEmployeeConversation(isClient: boolean, isRefresh: boolean = false) {
            this.isClientMessaging = isClient;
            this.$scope.$broadcast(MeevoMessengerMessages.OPEN_CLIENT_OR_EMPLOYEE_CONVERSATION, {isClient, isRefresh})
        }

        toggleAutoReplys() {
            this.$scope.$broadcast(MeevoMessengerMessages.TOGGLE_AUTO_REPLIES);
        }

        isPulsingModule(classification: TMeevoMessengerClassification, isPulsing) {
            let moduleClassification;

            switch (classification) {
                case this.messengerClassification.TEXTEL:
                    moduleClassification = MessengersEnum.MeevoMessengerTextel;
                    break;
                case this.messengerClassification.ARRIVALS:
                    moduleClassification = MessengersEnum.MeevoMessengerArrivals;
                    break;
                case this.messengerClassification.CLIENTAPP:
                    moduleClassification = MessengersEnum.MeevoMessengerClientApp;
                    break;
                case this.messengerClassification.TWOWAYSMS:
                    moduleClassification = MessengersEnum.MeevoMessengerTwoWaySms;
                    break;
                default:
                    this.openClientOrEmployeeConversation(this.isClientMessaging, true);
                    break;
            }
            this.inboundSmsFor = moduleClassification;

            if (this.meevoMessengerModules[moduleClassification]) this.meevoMessengerModules[moduleClassification].isPulsing = isPulsing;
            if (moduleClassification == MessengersEnum.MeevoMessengerArrivals) {
                this.isPulsing = null;
            } else {
                this.isPulsing = isPulsing;
            }

            setTimeout(() => this.$scope.$apply(), 0);
        }

        //TODO: CHECK this method if works correctly for TwoWaySms
        isPulsingClientEmployee(subMessengerModule): boolean {
            return subMessengerModule.isClient == this.isInboundSmsForClient && this.isPulsing && (this.inboundSmsFor == MessengersEnum.MeevoMessengerTextel || this.inboundSmsFor == MessengersEnum.MeevoMessengerTwoWaySms);
        }

        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
        }

        get activeMessengerEnum() {
            return MessengersEnum;
        }

    }

    angular.module('meevo.plugins.meevoMessenger')
        .controller('meevo.plugins.meevoMessenger.MeevoMessengerController', MeevoMessengerController);
}
